var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import CollapsingElement from "../../components/projecttablerows/collapsingelement.vue";
import HoverThumbnail from "../../components/hoverthumbnail.vue";
import PartInformationRow from "../../components/projecttablerows/partinformationrow.vue";
import { isSinglePart, } from "../utilities/documentdialog";
import { CheckedState, Column, articleName, } from "../utilities/projecttable";
let PartTableRow = class PartTableRow extends Vue {
    checkChange() { }
    click() { }
    articleDataChange(b) { return b; }
    type(columnName) { return columnName === Column.articleName ? "name" : ""; }
    get isSinglePart() { return isSinglePart(this.part); }
    get checked() { return this.displayInfo.checkedState === CheckedState.all; }
    get collapsedStateClass() { return "fas fa-chevron-" + (this.isOpened ? "down" : "right"); }
    get articleName() {
        return articleName(this.displayInfo, this.searchText);
    }
    get cssClasses() {
        if (!("partState" in this.part)) {
            throw Error("Missing part state.");
        }
        switch (this.part.partState) {
            case "userDefinedTube": {
                return {
                    selected: this.isOpened,
                    userDefinedTube: true,
                };
            }
            case "sheetCuttingPart": {
                return {
                    selected: this.isOpened,
                    sheetCuttingPart: true,
                };
            }
            case "sheetBendingPart": {
                return {
                    selected: this.isOpened,
                    sheetBendingPart: true,
                };
            }
            case "manufacturableWithWarning": {
                return {
                    selected: this.isOpened,
                    manufacturableWithWarning: true,
                };
            }
            case "notManufacturable": {
                return {
                    selected: this.isOpened,
                    notManufacturable: true,
                };
            }
            case "purchasedPart": {
                return {
                    selected: this.isOpened,
                    purchasedPart: true,
                };
            }
        }
        throw Error("Missing case in switch.");
    }
};
__decorate([
    Prop()
], PartTableRow.prototype, "assemblyNext", void 0);
__decorate([
    Prop({ required: true })
], PartTableRow.prototype, "animate", void 0);
__decorate([
    Prop({ required: true })
], PartTableRow.prototype, "columns", void 0);
__decorate([
    Prop({ required: true })
], PartTableRow.prototype, "displayInfo", void 0);
__decorate([
    Prop({ required: true })
], PartTableRow.prototype, "isOpened", void 0);
__decorate([
    Prop({ required: true })
], PartTableRow.prototype, "part", void 0);
__decorate([
    Prop({ required: true })
], PartTableRow.prototype, "Renderer3d", void 0);
__decorate([
    Prop({ required: true })
], PartTableRow.prototype, "rowIndex", void 0);
__decorate([
    Prop({ required: true })
], PartTableRow.prototype, "searchText", void 0);
__decorate([
    Prop({ required: true })
], PartTableRow.prototype, "shopConfig", void 0);
__decorate([
    Inject()
], PartTableRow.prototype, "i18n", void 0);
__decorate([
    Emit()
], PartTableRow.prototype, "checkChange", null);
__decorate([
    Emit()
], PartTableRow.prototype, "click", null);
__decorate([
    Emit()
], PartTableRow.prototype, "articleDataChange", null);
PartTableRow = __decorate([
    Component({
        components: {
            CollapsingElement,
            HoverThumbnail,
            PartInformationRow,
        },
        name: "PartTableRow",
    })
], PartTableRow);
export default PartTableRow;
